/**
 * The six Stitch prototype screens (Situation Watch, Your Money, Attention
 * Radar, Evidence Graph, Symbol Intel, component HUD) render HARDCODED figures
 * — Wilson intervals, contagion probabilities, an evidence hash, a stop-loss
 * instruction — none of which come from Fahali's judged record, and one of
 * which is advice. They were deployed 2026-10-08 16:58Z with Home's symbol
 * and Portfolio buttons rewired to them, so readers got invented numbers in
 * place of real ones (the honesty doctrine's one existential exposure).
 *
 * Off: routes unregistered, Home's original targets restored, entry points
 * hidden. The code stays. Turn this on per screen only once it reads its
 * figures from the API and labels what it cannot source.
 */
export const PROTOTYPE_SCREENS_LIVE = false;
